import { render, staticRenderFns } from "./GoogleSSOButton.vue?vue&type=template&id=20d43dc6&"
import script from "./GoogleSSOButton.vue?vue&type=script&lang=js&"
export * from "./GoogleSSOButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleSSOButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports